//
// Volume Button

volumeButton = {};

volumeButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  button._flags.muted = false;

  button.canEnable = function () {
    return soundManager.soundAvailable();
  };

  button.showButton = function () {
    if (Reflex.replayGame === true) {
      // we are the replay game, player could of pressed mute
      // but we wont know, because the soundManager would of told
      // the original games mute button
      // so we need to go and look at that and mirror it here
      // i think the easiest thing to do here is ask the soundManager if its muted or not
      button._flags.muted = soundManager.isMuted();
    }

    if (this.canShow()) {
      if (button._flags.muted) {
        this.button.buttonDisabled.tint = 0x999999;
        this.button.buttonEnabled.tint = 0x999999;

        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.tint = 0xffffff;
        this.button.buttonEnabled.tint = 0xffffff;

        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
    } else {
      this.hideButton();
    }
  };

  button.onPressedCallback = function () {
    messageBus.postImmediate('audio:stateChanged', {
      type: 'audio:stateChanged',
      muted: !this._flags.muted,
    });
  };

  button.onCurrentMuteState = function (state) {
    this._flags.muted = state.muted;
  };

  messageBus.subscribe('audio:currentMuteState', button.onCurrentMuteState.bind(button));

  return button;
};

volumeButton.initialise = function (json, object) {};
volumeButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'volumeButton',
  volumeButton.create,
  volumeButton.initialise,
  volumeButton.getFilesRequired
);
